import { useCallback, useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'
import { BottomSheet, Button, Flex, Text } from 'components/InterUI/InterUI'
import BaseBridge from 'config/bridge/BaseBridge'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'
import BannerWin from 'assets/png/game_banner_win.png'
import BannerLose from 'assets/png/game_banner_lose.png'

import { AnalyticsGameDeposit, AnalyticsGameFeedback, AnalyticsNewAttempt } from '../Game.tags'
import { IGameResultProps } from './GameResult.types'
import { PurchaseBottomSheet } from './PurchaseBottomSheet'
import * as S from './GameResultBottomSheet.styles'

export const GameResultBottomSheet = ({ ticketAwarded }: IGameResultProps) => {
  const history = useHistory()
  const isLoading = useBoundState((state) => state.isLoading)
  const { ticketId, prizeAmount } = useBoundState((state) => state.currentTicket)
  const availableTickets = useBoundState((state) => state.availableTickets)
  const { title, subtitle } = useBoundState((state) => state.completeTicket)

  const setUtmCampaign = useBoundState((state) => state.setUtmCampaign)
  const getCompleteScratchcard = useBoundState((state) => state.getCompleteScratchcard)
  const getTickets = useBoundState((state) => state.getTickets)

  const hasAvailableTickets = availableTickets && availableTickets.length > 1
  const [showPurchaseBS, setShowPurchaseBS] = useState(false)

  const handleResult = useCallback(() => {
    const actionId = ticketAwarded ? 'resultado positivo' : 'resultado negativo'
    AnalyticsGameDeposit(actionId)

    BaseBridge.ticWb({
      name: 'game_result_btn',
      module: 'capitalizacao',
      action: 'enter_after_sales_details',
      params: {},
    })

    if (ticketAwarded) {
      getTickets()
    }

    getCompleteScratchcard({
      ticketId,
      history,
      pathname: TypesRoutes.AFTER_SALES_DETAILS,
    })
  }, [getCompleteScratchcard, getTickets, history, ticketAwarded, ticketId])

  const registerResultBackListener = useCallback(() => {
    BaseBridge.addBackListener(handleResult)
  }, [handleResult])

  useEffect(() => {
    ticketAwarded ? AnalyticsGameFeedback(title, `${prizeAmount}`) : AnalyticsGameFeedback(title)
  }, [])

  useEffect(() => {
    registerResultBackListener()
  }, [registerResultBackListener])

  const handleNewAttempt = () => {
    AnalyticsNewAttempt(hasAvailableTickets)

    BaseBridge.ticWb({
      name: 'game_result_btn',
      module: 'capitalizacao',
      action: 'use_more_time',
      params: {},
    })

    if (hasAvailableTickets) {
      getTickets({ history, pathname: TypesRoutes.START })
      return
    }

    setUtmCampaign('purchase_incentive_retry')
    setShowPurchaseBS(true)
  }

  if (showPurchaseBS) {
    return (
      <PurchaseBottomSheet
        onClose={() => setShowPurchaseBS(false)}
        restoreBackListener={registerResultBackListener}
      />
    )
  }

  return (
    <BottomSheet onClose={handleResult}>
      <Flex gap="16px">
        <S.Banner $win={ticketAwarded}>
          <img src={ticketAwarded ? BannerWin : BannerLose} alt="Banner Win" />
        </S.Banner>
        <Text variant="headline-h1" as="h1" semiBold>
          {title}
        </Text>
        <Text variant="body-3">{subtitle}</Text>

        <Button
          data-testid="new-attempt"
          fullWidth
          onClick={handleNewAttempt}
          disabled={isLoading}
          isLoading={isLoading}
        >
          Tentar Novamente
        </Button>

        <Button
          data-testid="game-result-button"
          fullWidth
          onClick={handleResult}
          disabled={isLoading}
          isLoading={isLoading}
          variant="secondary"
        >
          Conferir sorteios
        </Button>
      </Flex>
    </BottomSheet>
  )
}
